import { USER_ROLES } from "./constants";

const TABS = [
    {
        eventKey: 1,
        title: "_current_orders_",
        type: "currentOrders",
        isOrders: true,
        path: "/active",
    },
    {
        eventKey: 2,
        title: "_delivered_orders_",
        type: "deliveredOrders",
        isDeliveredOrders: true,
        path: "/delivered",
    },
    {
        eventKey: 3,
        title: "_canceled_orders_",
        type: "canceledOrders",
        isCanceledOrders: true,
        path: "/canceled",
    },
    {
        eventKey: 4,
        title: "_map_",
        type: "map",
        isDistributors: true,
        path: "/map",
    },
    {
        eventKey: 5,
        title: "_call_center_",
        type: "callCenter",
        isCallCenter: true,
        path: "/callCenter",
    },
    {
        eventKey: 6,
        title: "_partner_",
        type: "partner",
        isRestaurant: true,
        path: "/partner",
    },
    {
        eventKey: 7,
        title: "_gift_card_",
        type: "giftCard",
        isGiftCard: true,
        path: "/giftCard",
    },
    {
        eventKey: 8,
        title: "_administrator_",
        type: "administrator",
        isAdmin: true,
        path: "/",
    },
    {
        eventKey: 9,
        title: "_other_",
        type: "other",
        isOther: true,
        path: "/other",
    },
    {
        eventKey: 10,
        title: "_printer_",
        type: "printer",
        isPrinter: true,
        path: "/printer",
    },
    {
        eventKey: 11,
        title: "_finance_",
        type: "finance",
        isFinance: true,
        path: "/finance",
    },
    {
        eventKey: 12,
        title: "_balance_",
        type: "balance",
        isBalance: true,
        path: "/balance",
    },
    {
        eventKey: 13,
        title: "_turnover_",
        type: "turnover",
        isTurnover: true,
        path: "/turnover",
    },
    {
        eventKey: 14,
        title: "_turnover_details_",
        type: "turnoverDetails",
        isTurnoverDetails: true,
        path: "/turnoverDetails",
    },
    {
        eventKey: 15,
        title: "_terminal_",
        type: "terminal",
        isTerminal: true,
        path: "/terminal",
    },
    {
        eventKey: 16,
        title: "_salary_",
        type: "salary",
        isSalary: true,
        path: "/salary",
    },
    {
        eventKey: 17,
        title: "_deactivated_users_",
        type: "deactivatedUsers",
        isDeactivatedUsers: true,
        path: "/deactivatedUsers",
    },
    {
        eventKey: 18,
        title: "_suppliers_automatic_report_",
        type: "suppliersAutomaticReport",
        isSuppliersAutomaticReport: true,
        path: "/suppliersAutomaticReport",
    },
    {
        eventKey: 19,
        title: "_quantitative_movement_",
        type: "quantitativeMovement",
        isQuantitativeMovement: true,
        path: "/quantitativeMovement",
    },
    {
        eventKey: 20,
        title: "_b2b_users_report_",
        type: "b2bUsersReport",
        isB2bUsersReport: true,
        path: "/b2bUsersReport",
    },
    {
        eventKey: 21,
        title: "_b2b_users_",
        type: "b2bUsers",
        isB2bUsers: true,
        path: "/b2bUsers",
    },
    {
        eventKey: 22,
        title: "_b2b_users_total_debt_",
        type: "b2bUsersTotalDebt",
        isB2bUsersTotalDebt: true,
        path: "/b2bUsersTotalDebt",
    },
    {
        eventKey: 23,
        title: "_material_means_report_",
        type: "materialMeansReport",
        isMaterialMeansReport: true,
        path: "/materialMeansReport",
    },
    {
        eventKey: 24,
        title: "_invalid_orders_",
        type: "invalidOrders",
        isInvalidOrders: true,
        path: "/invalidOrders",
    },
    {
        eventKey: 25,
        title: "_distributor_schedule_",
        type: "distributorSchedule",
        isDistributorSchedule: true,
        path: "/distributorSchedule",
    },
    {
        eventKey: 26,
        title: "_distributor_salary_report_",
        type: "distributorSalaryReport",
        isDistributorSalaryReport: true,
        path: "/distributorSalaryReport",
    },
    {
        eventKey: 27,
        title: "_configs_",
        type: "dispatchConfigs",
        isDispatchConfigs: true,
        path: "/dispatchConfigs",
    },
    {
        eventKey: 28,
        title: "_save_deposit_",
        type: "distributorSaveReport",
        isDistributorSaveReport: true,
        path: "/distributorSaveReport",
    },
    {
        eventKey: 29,
        title: "_refund_",
        type: "refundReport",
        isRefund: true,
        path: "/refund",
    },
    {
        eventKey: 30,
        title: "_delivery_price_report",
        type: "deliveryPriceReport",
        isDeliveryPriceReport: true,
        path: "/deliveryPriceReport",
    },
    {
        eventKey: 31,
        title: "_booked_orders_",
        type: "bookedOrders",
        isBookedOrders: true,
        path: "/booked",
    },
    {
        eventKey: 32,
        title: "_delivered_orders_updated",
        type: "deliveredOrdersUpdated",
        isDeliveredOrders: true,
        path: "/updated/delivered",
    },
    {
        eventKey: 33,
        title: "_distributors_",
        type: "distributors",
        isDistributors: true,
        path: "/distributors",
    },
];

export default {
    tabs: {
        [USER_ROLES.MANAGER]: [0, 1, 2, 3, 5, 18, 24, 26],
        [USER_ROLES.CALL_CENTER]: [4, 0, 1, 2, 3, 5],
        [USER_ROLES.ORDER_MANAGER]: [0, 1, 2, 30, 3, 4, 5, 6],
        [USER_ROLES.ADMIN]: [
            7, 0, 1, 2, 30, 3, 4, 5, 8, 6, 18, 9, 10, 11, 12, 13, 14, 15, 16,
            17, 19, 21, 22, 23, 25, 26, 32,
        ],
        [USER_ROLES.PARTNER_MANAGER]: [5, 10],
        [USER_ROLES.ACCOUNTANT]: [
            10, 11, 12, 13, 1, 6, 14, 15, 17, 19, 21, 22, 25,
        ],
        [USER_ROLES.SUPER_ADMIN]: [
            7, 0, 1, 31, 32, 2, 30, 3, 4, 5, 6, 8, 9, 18, 10, 11, 12, 13, 14, 15, 16,
            17, 19, 21, 22, 23, 24, 25, 26, 28
        ],
    },
    getTabs(role) {
        let userTabs = this.tabs[role] || [];
        return userTabs.map((id) => TABS[id]).filter(Boolean);
    },
};
